
import jQuery from "jquery";
import {ZIDX} from "../standalone/standaloneLibrary.js";

let $=jQuery.noConflict();

export class ZIDXAccountInit {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
        let self=this;
        $(".zidxAdminThemeLight", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            e.preventDefault();
            self.setTheme("light");
            $(".zidxAdminThemeLight", self.zidx.peakidxShadowRoot).addClass("zidxActive");
            $(".zidxAdminThemeDark", self.zidx.peakidxShadowRoot).removeClass("zidxActive");
        });
        $(".zidxAdminThemeDark", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            e.preventDefault();
            self.setTheme("dark");
            $(".zidxAdminThemeLight", self.zidx.peakidxShadowRoot).removeClass("zidxActive");
            $(".zidxAdminThemeDark", self.zidx.peakidxShadowRoot).addClass("zidxActive");
        });
        let adminTheme=localStorage.getItem('zidxAdminTheme');
        if(adminTheme==null){
            try {
                if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    adminTheme = "dark";
                } else {
                    adminTheme = "light";
                }
            }catch(e){
                adminTheme = "light";
            }
        }
        self.setTheme(adminTheme);
        $(".zidxAdminSidebarSelect", this.zidx.peakidxShadowRoot).on("change", function(this, e:JQuery.ChangeEvent){
            let siteId=(this as HTMLSelectElement).options[(this as HTMLSelectElement).selectedIndex].value;
            if(siteId!=""+self.zidx.options.selectedSiteId){
                if(siteId=="0") {
                    window.location.href='/account/sites?adminSiteId='+siteId;
                }else{
                    window.location.href='/account/sites/dashboard?adminSiteId='+siteId;
                }
            }
        });
    }
    setTheme(theme:string){
        let localTheme=localStorage.getItem("zidxAdminTheme");
        let self=this;
        if(theme=="dark"){
            $(".adminDarkThemeStylesheet", this.zidx.peakidxShadowRoot).prop("disabled", false);
            // $(".zidxHeaderLogoImg", this.zidx.peakidxShadowRoot).each(function(this:HTMLElement){
            //     (this as HTMLImageElement).src=self.zidx.getVersionURL("/static/images/peakidx-app-icon.svg", false);
            // });
        }else{
            $(".adminDarkThemeStylesheet", this.zidx.peakidxShadowRoot).prop("disabled", true);
            // $(".zidxHeaderLogoImg", this.zidx.peakidxShadowRoot).each(function(this){
            //     (this as HTMLImageElement).src=self.zidx.getVersionURL("/static/images/peakidx-app-icon.svg", false);
            // });
        }
        if(localTheme!=theme){
            this.zidx.setCookie({key:"zidxAdminTheme",value:theme,futureSeconds:365*60 * 60 * 24,enableSubdomains:true});
            localStorage.setItem("zidxAdminTheme", theme);
        }
    }
}
